import { ICameraVideoTrack, IMicrophoneAudioTrack, LocalUser, UID } from "agora-rtc-react";
import UserTrackInfo from "components/UserTrackInfo";
import PinStream from "./PinSteam";

const LocalUserSteam = ({
  audioTrack,
  videoTrack,
  cameraOn,
  micOn,
  userClassName = "",
  userId,
}: {
  audioTrack: IMicrophoneAudioTrack | null;
  videoTrack: ICameraVideoTrack | null;
  cameraOn: boolean;
  micOn: boolean;
  userClassName?: string | undefined;
  userId: UID;
}) => {
  return (
    <div className={`pin-user-wrapper position-relative user ${userClassName}`}>
      <LocalUser
        className='localUser pinnedUserContainer'
        audioTrack={audioTrack}
        cameraOn={cameraOn}
        micOn={micOn}
        videoTrack={videoTrack}
        playAudio={false}
      >
        <UserTrackInfo isLocal={true} />
      </LocalUser>

      <PinStream userId={userId} />
    </div>
  );
};

export default LocalUserSteam;
